<button type="button" [ngClass]="customClass" [ngStyle]="customStyles" [disabled]="isLoading || isDisabled">
   <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isLoading"></span>
   <ng-content></ng-content> {{ label }}
</button>